export const api = {
  url: process.env.REACT_APP_API_URL,
  auth: {
    username: 'cds',
    password: 'cds12345',
  },
}
